/* @flow */
import _ from 'lodash'
import moment from 'moment'
import React, { useRef, useCallback } from 'react'
import { View, Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import Svg, { Line, Polygon } from 'react-native-svg'

import LunarDate, { STEMS, BRANCHES } from '../../../../api/LunarDate'
import styles from './style'

type Props = {
  theme: Object,
  ta: Object,
  astrolabe: Object,
  relationship: number,
  t: Function,
}
const Desc = ({ theme, ta, astrolabe, relationship }: Props) => {
  const { palette } = theme
  const { t } = useTranslation()
  const relations = useRef([])

  const onLayout = useCallback(event => {
    let { width, height } = event.nativeEvent.layout

    const setupTriLines = (p1, p2, p3) => {
      return [
        [p1.x, p1.y].join(','),
        [p2.x, p2.y].join(','),
        [p3.x, p3.y].join(','),
      ].join(' ')
    }

    let triQuad = new Array(12)
    if (width && height) {
      let w = width,
        h = height
      // eslint-disable-next-line prettier/prettier
      triQuad[0]  = { x1: w * 3/4, y1: h,       x2: w/4,     y2: 0,       polys: setupTriLines({x: 0, y: h/4},     {x: w, y: 0},       {x: w * 3/4, y: h}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[1]  = { x1: w/4,     y1: h,       x2: w * 3/4, y2: 0,       polys: setupTriLines({x: 0, y: 0},       {x: w, y: h/4},     {x: w/4, y: h}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[2]  = { x1: 0,       y1: h,       x2: w,       y2: 0,       polys: setupTriLines({x: w/4, y: 0},     {x: w, y: h * 3/4}, {x: 0, y: h}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[3]  = { x1: 0,       y1: h * 3/4, x2: w,       y2: h/4,     polys: setupTriLines({x: w * 3/4, y: 0}, {x: w, y: h},       {x: 0, y: h * 3/4}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[4]  = { x1: 0,       y1: h/4,     x2: w,       y2: h * 3/4, polys: setupTriLines({x: w, y: 0},       {x: w * 3/4, y: h}, {x: 0, y: h/4}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[5]  = { x1: 0,       y1: 0,       x2: w,       y2: h,       polys: setupTriLines({x: w, y: h/4},     {x: w/4, y: h},     {x: 0, y: 0}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[6]  = { x1: w/4,     y1: 0,       x2: w * 3/4, y2: h,       polys: setupTriLines({x: w, y: h * 3/4}, {x: 0, y: h},       {x: w/4, y: 0}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[7]  = { x1: w * 3/4, y1: 0,       x2: w/4,     y2: h,       polys: setupTriLines({x: w, y: h},       {x: 0, y: h * 3/4}, {x: w * 3/4, y: 0}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[8]  = { x1: w,       y1: 0,       x2: 0,       y2: h,       polys: setupTriLines({x: w * 3/4, y: h}, {x: 0, y: h/4},     {x: w, y: 0}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[9]  = { x1: w,       y1: h/4,     x2: 0,       y2: h * 3/4, polys: setupTriLines({x: w/4, y: h},     {x: 0, y: 0},       {x: w, y: h/4}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[10] = { x1: w,       y1: h * 3/4, x2: 0,       y2: h/4,     polys: setupTriLines({x: 0, y: h},       {x: w/4, y: 0},     {x: w, y: h * 3/4}) }
      // eslint-disable-next-line prettier/prettier
      triQuad[11] = { x1: w,       y1: h,       x2: 0,       y2: 0,       polys: setupTriLines({x: 0, y: h * 3/4}, {x: w * 3/4, y: 0}, {x: w, y: h}) }
    }

    relations.current = triQuad
  }, [])

  let taLunarDate = new LunarDate(ta.lunarDate)
  let today = new Date()
  let lunarToday = new LunarDate(today)
  return (
    <View style={styles.desc} onLayout={onLayout}>
      <Text style={styles.today}>
        今日：{moment(today).format('YYYY-MM-DD')}
      </Text>
      <Text style={styles.today}>流日：{lunarToday.toString(t)}</Text>
      {!_.isEmpty(ta) ? (
        <View>
          <Text style={styles.name}>{ta.name}</Text>
          <Text style={styles.default}>
            {astrolabe.ziweiSex} (虛
            {lunarToday.year - taLunarDate.year + 1}歲)
          </Text>
          <Text style={styles.default}>{astrolabe.wuxing}</Text>
          <Text style={styles.default}>
            生日：{taLunarDate.toWesternDate().toLocaleString()}
          </Text>
          <Text style={styles.default}>農曆：{taLunarDate.toString(t)}</Text>
          <Text style={styles.default}>命主：{astrolabe.selfLord}</Text>
          <Text style={styles.default}>身主：{astrolabe.lifeLord}</Text>
          <Text style={styles.default}>子斗：{astrolabe.zidou}</Text>
          <Text style={styles.default}>流斗：{astrolabe.currentZidou}</Text>
        </View>
      ) : null}
      {relationship >= 0 ? (
        <Svg style={styles.canvas}>
          <Line
            x1={relations.current[relationship].x1}
            y1={relations.current[relationship].y1}
            x2={relations.current[relationship].x2}
            y2={relations.current[relationship].y2}
            stroke={palette.self}
          />
          <Polygon
            fill="none"
            points={relations.current[relationship].polys}
            stroke={palette.self}
          />
        </Svg>
      ) : null}
    </View>
  )
}
export default Desc
